import { Injectable } from '@angular/core'
import { Router, Resolve } from '@angular/router'
import { catchError, map, Observable, of } from 'rxjs'
import { ROUTER_STATE_KEY_PREVENT_LOGIN_REDIRECT } from '../constants/router-state-keys'

@Injectable({
    providedIn: 'root',
})
export class LoginResolver implements Resolve<boolean> {
    constructor(private readonly router: Router) {}

    resolve(): Observable<boolean> {
        return this.router.getCurrentNavigation()?.extras?.state?.[
            ROUTER_STATE_KEY_PREVENT_LOGIN_REDIRECT
        ]
            ? of(true)
            : of(this.router.navigate(['/cases'])).pipe(
                  map(() => false),
                  catchError(err => {
                      console.error(err)
                      return of(true)
                  })
              )
    }
}
